import * as React from "react";

/**
 * PWA / mező használat — Fieldwire offline jelzés minta.
 * Sync on mount: after offline hard-reload there is often no `offline` event
 * (page already starts offline), so relying only on listeners can leave the
 * initial `navigator.onLine` snapshot stuck wrong.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = React.useState(() =>
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  React.useEffect(() => {
    const sync = () => setOnline(navigator.onLine);
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    // SW + Playwright offline can leave onLine stale briefly after navigation
    const id = window.setInterval(sync, 1000);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
      window.clearInterval(id);
    };
  }, []);

  return online;
}
